import styled from 'styled-components';
import { dividerStyle, flexStyle, gutterStyle } from '../../styles';

export const Articles = styled.section`
  ${flexStyle}
  ${dividerStyle}
  ${gutterStyle}

  .pj-ui-panel-header--header {
    margin-bottom: 1rem;
  }
`;
